module.exports = __webpack_public_path__ + "img/qiangzhiDialog.8af35a88.png";